import _ from 'lodash';
import React from 'react';
import DrawerLink from '../components/common/drawers/ModuleDrawer/DrawerLink';
import { archiveFilter, tagFilter } from '../components/common/filters/consts';
import { IFilter } from '../components/common/filters/interfaces';
import RolesPopover from '../components/common/popover/RolesPopover';
import { AccountAvailableColumns } from '../services/react-query/accounts';
import { Account } from '../types/Account';
import { Preference } from '../types/Preference';
import { UserConfigurableModule } from '../types/User';
import { AvailableColumn } from '../uikit/itable/ITable';
import { mapOptionsFromPreferences } from '../utility/filterUtils';
import PreferencePill from '../components/preferences/PreferencePill';
import PhoneLink from '../components/common/PhoneLink/PhoneLink';
import EmailLink from '../components/common/EmailLink/EmailLink';

export const AccountColumns: AvailableColumn<Account, AccountAvailableColumns>[] = [
  {
    key: 'name',
    label: 'Name',
    render: (account) => (
      <DrawerLink module={UserConfigurableModule.ACCOUNTS} uuid={account.uuid}>
        {account.name}
      </DrawerLink>
    ),
  },
  {
    key: 'code',
    label: 'Code',
    render: (account) => (
      <DrawerLink module={UserConfigurableModule.ACCOUNTS} uuid={account.uuid}>
        {account.code}
      </DrawerLink>
    )
  },
  {
    key: 'phone',
    label: 'Phone',
    render: (account) => <PhoneLink phone={account.phone} />
  },
  {
    key: 'manager_display_name',
    label: 'Manager Name',
    render: (account) => (
      <DrawerLink module={UserConfigurableModule.EMPLOYEES} uuid={account.manager_uuid || ''}>
        {account.manager_display_name}
      </DrawerLink>
    )
  },
  {
    key: 'manager_email',
    label: 'Manager Email',
    render: (account) =>  <EmailLink email={account.manager_email} />,
  },
  {
    key: 'school_district_value',
    label: 'School District',
    render: (account) => account.school_district_value,
  },
  {
    key: 'status_value',
    label: 'Status',
    render: (account) => {
      const value: string = account.status_value ?? '';
      const color = account.status_color ?? null;
      return <PreferencePill value={value} color={color} />;
    },
  },
  {
    key: 'type_value',
    label: 'Type',
    render: (account) => account.type_value,
  },
  {
    key: 'tags',
    label: 'Tags',
    render: (account) => <RolesPopover roles={_.map(account.tags, 'preference_value')} />,
    sortable: false,
  },
];

export const AccountFilters = (preferences?: Preference[]): IFilter[] => [
  {
    label: 'Account Type',
    key: 'account_type',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'account_type'),
  },
  {
    label: 'Account Status',
    key: 'account_status',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'account_status'),
  },
  {
    label: 'Account Manager',
    key: 'account_manager',
    type: 'employee',
  },
  tagFilter,
  archiveFilter,
];
